'use strict';

const Enum = require('./enum');

module.exports.DEFAULT_KEYPAD_SERIAL_NUMBER = 'keypad-firmware-record-default';

module.exports.ONE_TOUCH_LOCK_USER_ID = 'onetouchlock';
module.exports.ONE_TOUCH_LOCK_USER_FIRST_NAME = 'One-Touch';
module.exports.ONE_TOUCH_LOCK_USER_LAST_NAME = 'Lock';

module.exports.MERCURY_ACTION = 'lockdata';
module.exports.MERCURY_AGENT = 'mercury';
module.exports.MERCURY_DEVICE = 'lock';
module.exports.MERCURY_KEYPAD = true;

module.exports.PANDORA_AGENT = 'pandora';
module.exports.PANDORA_DEVICE = 'lock';

module.exports.MERCURY_PUBLISH_ACTIONS = ['lock', 'unlock', 'onetouchlock', 'invalidcode'];

module.exports.MERCURY_LOG_ACTIONS = {
  KeypadOpen: 'unlock',
  KeypadClose: 'lock',
  KeypadOneTouch: 'onetouchlock',
  KeypadWrongCode: 'invalidcode',
  KeypadAddPin: 'addedpin',
  KeypadRemovePin: 'removedpin',
  KeypadEnabledPin: 'enabledpin',
  KeypadDisabledPin: 'disabledpin',
  KeypadUpdatePin: 'updatedpin',
};

module.exports.UNITY_MASTER_PIN_SLOT = 65518;

module.exports.UNITY_LOG_ACTIONS = {
  CodeAdded: 'addedpin',
  CodeAddedv2: 'addedpin',
  CodeDeleted: 'removedpin',
  CodeDeletedv2: 'removedpin',
  AllCodesDeleted: 'removedallpins',
  CodeOperation: 'operatedpin',
  FactoryReset: 'factoryreset',
};

module.exports.MERCURY_LOG_ONE_TOUCH = {
  name: 'KeypadOneTouch',
  type: 'LockOperation',
  code: 'DoorStateChanged',
  slot: 255,
};

module.exports.UNITY_LOG_ONE_TOUCH = {
  name: 'KeypadOneTouch',
  type: 'LockOperation',
  code: 'OneTouch',
  slot: 0,
};

module.exports.MERCURY_LOG_ATTRS = {
  time: 'timeStamp',
  type: 'log_type',
  slot: 'keySlot',
  code: 'opCode',
  pin: 'keycode',
};

module.exports.UNITY_LOG_ATTRS = {
  type: 'log_type',
  time: 'timeStamp',
  currentLockState: 'currentLockState',
  currentDoorState: 'currentDoorState',
  slot: 'slot',
  error: 'error',
  batteryLevel: 'batteryLevel',
  batteryLevelPercent: 'batteryLevelPercent',
  code: 'code',
  credentialType: 'credentialType',
  credentialError: 'credentialError',
};

module.exports.MERCURY_LOG_ACTIONS_TO_FILTER = ['KeypadOpen', 'KeypadClose', 'KeypadOneTouch', 'KeypadWrongCode'];

// https://augusthome.atlassian.net/wiki/display/MERC/Low+Battery+Behavior
module.exports.KeypadBatteryThresholds = Object.create(Enum, {
  K1: {
    enumerable: true,
    value: {
      criticalKeypadBatteryLevel: 130,
      lowKeypadBatteryLevel: 140,
      freshKeypadBatteryLevel: 185,
    },
  },
  K2: {
    enumerable: true,
    value: {
      criticalKeypadBatteryLevel: 130,
      lowKeypadBatteryLevel: 140,
      freshKeypadBatteryLevel: 185,
    },
  },
});

/**
 * Defines keypad battery levels.
 *
 * @enum
 * @readonly
 */
module.exports.KeypadBatteryLevels = Object.create(Enum, {
  MAX: {
    value: 255,
    enumerable: true,
  },
  MIN: {
    value: 0,
    enumerable: true,
  },
});

/**
 * Defines keypad battery conditions
 * by percentages.
 *
 * @enum
 * @readonly
 */
module.exports.KeypadBatteryPercentages = Object.create(Enum, {
  VERY_LOW: {
    enumerable: true,
    value: {
      K1: 49,
      K2: 50,
    },
  },
  LOW: {
    enumerable: true,
    value: {
      K1: 57,
      K2: 55,
    },
  },
  MEDIUM: {
    enumerable: true,
    value: {
      K1: 68,
      K2: 70,
    },
  },
  FULL: {
    enumerable: true,
    value: {
      K1: 100,
      K2: 100,
    },
  },
  toTranslationKey: {
    value: function(percentage, keypadType = 'K1') {
      if (!['K1', 'K2'].includes(keypadType)) {
        throw new Error('invalid keypad type');
      }

      switch (true) {
        case percentage <= this.VERY_LOW[keypadType]:
          return 'keypadBatteryPercentageVeryLow';

        case percentage <= this.LOW[keypadType]:
          return 'keypadBatteryPercentageLow';

        case percentage <= this.MEDIUM[keypadType]:
          return 'keypadBatteryPercentageMedium';

        case percentage <= this.FULL[keypadType]:
          return 'keypadBatteryPercentageFull';

        default:
          return 'keypadBatteryPercentageUnknown';
      }
    },
    enumerable: false,
  },
  toString: {
    value: function(percentage, keypadType) {
      const stringKey = this.toTranslationKey(percentage, keypadType);
      switch (stringKey) {
        case 'keypadBatteryPercentageVeryLow':
          return 'Very Low';

        case 'keypadBatteryPercentageLow':
          return 'Low';

        case 'keypadBatteryPercentageMedium':
          return 'Medium';

        case 'keypadBatteryPercentageFull':
          return 'Full';

        case 'keypadBatteryPercentageUnknown':
        default:
          return 'invalid percentage';
      }
    },
    enumerable: false,
  },
});

module.exports.KeypadCypherDefaults = Object.create(Enum, {
  LOW: { value: '00000000', enumerable: true },
  HIGH: { value: '00000000', enumerable: true },
  LOW_PARAM: { value: 0, enumerable: true },
  HIGH_PARAM: { value: 0, enumerable: true },
});

module.exports.KeypadVersions = Object.create(
  {},
  {
    typeToVersionString: {
      value: function(keypadType) {
        const isValid = typeof keypadType === 'number';
        if (!isValid) {
          throw new TypeError(`Invalid keypad type ${keypadType}`);
        }

        return `keypad_version_${keypadType}`;
      },
      enumerable: false,
    },
  }
);

module.exports.KEYPAD_STATE_BATTERY_WARNING_NONE = 'keypad_state_battery_warning_none';
module.exports.KEYPAD_STATE_BATTERY_WARNING_WARNING = 'keypad_state_battery_warning_warning';
module.exports.KEYPAD_STATE_BATTERY_WARNING_CRITICAL = 'keypad_state_battery_warning_critical';
